const routes = [
  {
    path: '/pages/user/user',
    name: 'user',
    meta: {
      title: "我的",
      requiresAuth: true
    },
    component: () => import('../pages/user/user.vue')
  },
  {
    path: '/pages/user/homePageNew/index',
    name: 'homePageNew',
    meta: {
      title: "个人主页",
      requiresAuth: true,
      keepAlive: false
    },
    component: () => import('../pages/user/homePageNew/index.vue')
  },
  {
    path: '/pages/user/setView/set/index',
    name: 'setView',
    meta: {
      title: "设置"
    },
    component: () => import('../pages/user/setView/set/index.vue')
  },
  {
    path: '/pages/user/cheangename',
    name: 'cheangename',
    meta: {
      title: "修改昵称"
    },
    component: () => import('../pages/user/cheangename/cheangename.vue')
  },
  {
    path: '/pages/user/setView/accountAndSecurity',
    name: 'accountAndSecurity',
    meta: {
      title: "账号与安全"
    },
    component: () => import('../pages/user/setView/set/accountAndSecurity.vue')
  },
  {
    path: '/pages/user/setView/changePassword',
    name: 'ChangePassword',
    component: () => import('@/pages/user/setView/changePassword/changePassword.vue'),
    meta: {
      title: '修改密码',
      keepAlive: false
    }
  },
  {
    path: '/pages/user/setView/realName',
    name: 'RealName',
    component: () => import('@/pages/user/setView/realName/realName.vue'),
    meta: {
      title: '实名认证',
      keepAlive: false
    }
  },
  {
    path: '/pages/user/setView/changePhone',
    name: 'ChangePhone',
    component: () => import('@/pages/user/setView/changePhone/changePhone.vue'),
    meta: {
      title: '修改手机号',
      keepAlive: false
    }
  },
  {
    path: '/pages/user/setView/werrtoff',
    name: 'Werrtoff',
    component: () => import('@/pages/user/setView/werrtoff.vue'),
    meta: {
      title: '注销账号',
      keepAlive: false
    }
  },
  {
    path: '/pages/user/setView/myRole',
    name: 'MyRole',
    component: () => import('@/pages/user/setView/myRole/myRole.vue'),
    meta: {
      title: '常用角色',
      keepAlive: false
    }
  },
  {
    path: '/pages/user/setView/teenmode',
    name: 'TeenMode',
    component: () => import('@/pages/user/setView/teenmode.vue'),
    meta: {
      title: '青少年模式',
      keepAlive: false
    }
  },
  {
    path: '/pages/user/setView/regard',
    name: 'Regard',
    component: () => import('@/pages/user/setView/set/regard.vue'),
    meta: {
      title: '关于我们',
      keepAlive: false
    }
  },
  {
    path: '/pages/user/setView/clearcache/clearcache',
    name: 'ClearCache',
    component: () => import('@/pages/user/setView/set/clearcache/clearcache.vue'), // 修改导入路径
    meta: {
      title: '存储空间管理',
      keepAlive: false
    }
  },
  {
    path: '/pages/user/myOrder/myOrder',
    name: 'MyOrder',
    component: () => import('@/pages/user/myOrder/myOrder.vue'),
    meta: {
      title: '订单列表',
      keepAlive: false
    }
  },
  {
    path: '/pages/user/myOrder/orderDetail',
    name: 'OrderDetail',
    component: () => import('@/pages/user/myOrder/orderDetail.vue'),
    meta: {
      title: '订单详情',
      keepAlive: false
    }
  },
  {
    path: '/pages/user/myFans',
    name: 'MyFans',
    component: () => import('@/pages/user/myFans/myFans.vue'),
    meta: {
      title: '我的粉丝',
      keepAlive: false
    }
  },
  {
    path: '/pages/user/myGift/myGift',
    name: 'MyGift',
    component: () => import('@/pages/user/myGift/myGift.vue'),
    meta: {
      title: '我的礼包',
      keepAlive: false,
      isLogin: true
    }
  },
  {
    path: '/pages/user/myCollect/myCollect',
    name: 'myCollect',
    component: () => import('@/pages/user/myCollect/myCollect.vue'),
    meta: {
      title: '收藏商品',
      keepAlive: false
    }
  },
  {
    path: '/pages/user/member/member',
    name: 'member',
    component: () => import('@/pages/user/member/member.vue'),
    meta: {
      title: '会员中心',
      keepAlive: true
    }
  },
  {
    path: '/pages/user/member/giftMore',
    name: 'giftMore',
    component: () => import('@/pages/user/member/giftMore.vue'),
    meta: {
      title: '会员中心更多礼包',
      keepAlive: true
    }
  },

  // 
  {
    path: '/pages/user/memberBenefits/memberBenefits',
    name: 'memberBenefits',
    component: () => import('@/pages/user/memberBenefits/memberBenefits.vue'),
    meta: {
      title: '会员权益',
      keepAlive: false
    }
  },

  {
    path: '/pages/user/memberGrowthValue/memberGrowthValue',
    name: 'memberGrowthValue',
    component: () => import('@/pages/user/memberGrowthValue/memberGrowthValue.vue'),
    meta: {
      title: '会员权益',
      keepAlive: false
    }
  },

  {
    path: '/pages/user/searchGame/searchGame',
    name: 'searchGame',
    component: () => import('@/pages/user/searchGame/searchGame.vue'),
    meta: {
      title: '角色游戏搜索',
      keepAlive: false
    }
  },
  {
    path: '/pages/user/noticeCenter/noticeCenter',
    name: 'noticeCenter',
    component: () => import('@/pages/user/noticeCenter/noticeCenter.vue'),
    meta: {
      title: '消息通知',
      keepAlive: false,
      isLogin: true
    }
  },
  {
    path: '/pages/user/awardPage/awardPage',
    name: 'awardPage',
    component: () => import('@/pages/user/awardPage/awardPage.vue'),
    meta: {
      title: '获奖通知',
      keepAlive: false
    }
  },
  {
    path: '/pages/user/information/informationList',
    name: 'informationList',
    component: () => import('@/pages/user/information/informationList.vue'),
    meta: {
      title: '消息详情',
      keepAlive: false
    }
  },
  // /pages/user/wishList/wishList
  {
    path: '/pages/user/wishList/wishList',
    name: 'wishList',
    component: () => import('@/pages/user/wishList/wishList.vue'),
    meta: {
      title: '心愿单',
      keepAlive: false
    }
  },
  // /pages/user/communityHelp/communityHelp
  {
    path: '/pages/user/communityHelp/communityHelp',
    name: 'communityHelp',
    component: () => import('@/pages/user/communityHelp/communityHelp.vue'),
    meta: {
      title: '社区帮助',
      keepAlive: false
    }
  },

  {
    path: '/pages/user/followUser/followUser',
    name: 'followUser',
    component: () => import('@/pages/user/followUser/followUser.vue'),
    meta: {
      title: '关注的人',
      keepAlive: false
    }
  },
  {
    path: '/pages/user/myFans/myFans',
    name: 'myFans',
    component: () => import('@/pages/user/myFans/myFans.vue'),
    meta: {
      title: '我的粉丝',
      keepAlive: false
    }
  },
  {  //
    path: '/pages/user/myOrder/orderDetail',
    name:'orderDetail',
    component: () => import('@/pages/user/myOrder/orderDetail.vue'),
    meta: {
      title: '订单详情',
      keepAlive: false
    }
  },

  {
    path: '/pages/recharge/rechargeCenter/rechargeCenter',
    name: 'rechargeCenter',
    component: () => import('@/pages/recharge/rechargeCenter/rechargeCenter.vue'),
    meta: {
      title: '充值中心',
      keepAlive: false
    }
  },
  {
    path: '/pages/recharge/gameRecharge',
    name: 'gameRecharge',
    component: () => import('@/pages/recharge/gameRecharge.vue'),
    meta: {
      title: '游戏充值',
      keepAlive: false,
      isLogin: true
    }
  },
  {
    path: '/pages/recharge/rechargeRecord/rechargeRecord',
    name: 'rechargeRecord',
    component: () => import('@/pages/recharge/rechargeRecord/rechargeRecord.vue'),
    meta: {
      title: '游戏充值记录',
      keepAlive: false
    }
  },
  {
    path: '/pages/shop/pay/rechargePay',
    name: 'rechargePay',
    component: () => import('@/pages/shop/pay/rechargePay.vue'),
    meta: {
      title: '游戏充值支付',
      keepAlive: false
    }
  },
  {
    path: '/pages/shop/pay/rechargeResult',
    name: 'rechargeResult',
    component: () => import('@/pages/shop/pay/rechargeResult.vue'),
    meta: {
      title: '游戏充值支付成功',
      keepAlive: false
    }
  },
  // /pages/daySignin/recordList/recordList
  {
    path: '/pages/daySignin/recordList/recordList',
    name:'recordList',
    component: () => import('@/pages/daySignin/recordList/recordList.vue'),
    meta: {
      title: '签到记录',
      keepAlive: false
    }
  },
  {
    path: '/pages/user/kf/kf',
    name:'kf',
    component: () => import('@/pages/user/kf/kf.vue'),
    meta: {
      title: '客服中心',
    }
  },
  {
    path: '/pages/user/kf/noticeDetail/noticeDetail',
    name:'kfnoticeDetail',
    component: () => import('@/pages/user/kf/noticeDetail/noticeDetail.vue'),
    meta: {
      title: '公告详情',
    }
  },
  {
    path: '/pages/user/kf/cjwtDetail/cjwtDetail',
    name:'cjwtDetail',
    component: () => import('@/pages/user/kf/cjwtDetail/cjwtDetail.vue'),
    meta: {
      title: '常见问题',
    }
  },
  {
    path: '/pages/user/kf/fqlList/fqlList',
    name:'fqlList',
    component: () => import('@/pages/user/kf/fqlList/fqlList.vue'),
    meta: {
      title: '游戏FAQ',
    }
  },
  {
    path: '/pages/user/kf/Servicerecord/Servicerecord',
    name:'Servicerecord',
    component: () => import('@/pages/user/kf/Servicerecord/Servicerecord.vue'),
    meta: {
      title: '客服记录',
    }
  },
  {
    path: '/pages/user/kf/workorderDetail/workorderDetail',
    name:'workorderDetail',
    component: () => import('@/pages/user/kf/workorderDetail/workorderDetail.vue'),
    meta: {
      title: '客服记录详情',
    }
  },
  {
    path: '/pages/customer/index',
    name:'customer',
    component: () => import('@/pages/customer/index.vue'),
    meta: {
      title: '在线客服',
    }
  },
  {
    path: '/pages/customer/workOrder',
    name:'workOrder',
    component: () => import('@/pages/customer/workOrder.vue'),
    meta: {
      title: '提交工单',
    }
  },

]

export default routes
